import script from "./SectionDocumentHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionDocumentHtml.vue?vue&type=script&setup=true&lang=js"

import "./SectionDocumentHtml.vue?vue&type=style&index=0&id=0d624d41&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d624d41"]])

export default __exports__